import { CopyableText } from "@bezoned/shared/components/copyable-text.jsx";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Title2,
  Body2,
} from "@fluentui/react-components";

interface TeamInstallationSuccessProps {
  redirect: {
    url: string;
    openInNewTab: boolean;
  };
  msTeamId: string | null;
}

export const TeamInstallationSuccess = ({
  redirect: { url, openInNewTab = false },
  msTeamId,
}: TeamInstallationSuccessProps) => (
  <Card size="large" className="w-full max-w-lg">
    <CardHeader header={<Title2>BeZoned installed</Title2>} />

    <Body2>
      BeZoned was successfully installed in this team. To use it, please
      complete office setup in the BeZoned lobby.
    </Body2>

    <Body2>You may need Team ID on hand:</Body2>
    <CopyableText
      value={msTeamId ?? ""}
      className="text-sm break-all text-gray-800"
    />

    <CardFooter className="flex justify-end gap-2">
      <Button
        appearance="primary"
        as="a"
        href={url}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        target={openInNewTab ? "_blank" : undefined}
      >
        Open Lobby
      </Button>
    </CardFooter>
  </Card>
);
